import React from 'react';
import SlideOutSidebar from 'ui-components/slide-out-sidebar/slideOutSidebar';
import { useSelector } from 'react-redux';
import { driversSelector } from 'slices/drivers/driversSlice';
import DriverDetails from './sections/driverDetails';
import EditDriverDetails from './sections/editDriverDetails';
import './drivers.scss';

interface FilterSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  isEditing: boolean;
  handleEdit: () => void;
}

const DriverDetailsSidebar: React.FC<FilterSidebarProps> = ({ isOpen, onClose, isEditing, handleEdit }) => {
  const driverState = useSelector(driversSelector);

  return (
    <SlideOutSidebar
      show={isOpen}
      onClose={onClose}
      header={driverState.selectedDriver?.firstName + " " + driverState.selectedDriver?.lastName}
      size="small"
      className="filter-sidebar"
    >
      {isEditing ?
        <EditDriverDetails isEditing={isEditing} onCancel={handleEdit} />
        : <DriverDetails handleEdit={handleEdit} />
      }
    </SlideOutSidebar >
  );
};

export default DriverDetailsSidebar;
